import { appConfig } from '@utils/appConfig';

export const config = {
  tenantId: appConfig.TENANT_ID,
  clientId: appConfig.CLIENT_ID,
  apiClientId: appConfig.API_CLIENT_ID,
  azureCache: appConfig.AZURE_CACHE,
};
